import DirectoryList from "@/components/business/DirectoryList";
import SeoHead from "@/components/seo/SeoHead";
import {
  SEO_DEFAULT_IMAGE_URL,
  SEO_HOME_DESCRIPTION,
  SEO_HOME_TITLE,
  buildCanonicalUrl,
} from "@/lib/seo";

export default function DirectoryScreen() {
  return (
    <>
      <SeoHead
        title={SEO_HOME_TITLE}
        description={SEO_HOME_DESCRIPTION}
        canonicalUrl={buildCanonicalUrl("/directory")}
        imageUrl={SEO_DEFAULT_IMAGE_URL}
      />
      <DirectoryList />
    </>
  );
}
